import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Observable, from } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export class StpTranslateLoader extends TranslateHttpLoader {
    private httpClient: HttpClient;
        constructor(http: HttpClient, prefix?: string, suffix?: string) {
            super(http, prefix, suffix);
            this.httpClient = http;

    }

    getTranslation(lang: string): Observable<Record<string, string>> {
        return super.getTranslation(lang)
            .pipe(switchMap(translations =>
                this.getTranslations(lang).pipe(map(additionalTranslations => Object.assign(translations, additionalTranslations)))));
    }

    getTranslations(lang: string): Observable<Record<string, string>> {
        return this.httpClient.get(`${environment.serverUrl}translations/${lang}/fetch`, {}).pipe(catchError(() => from([])));
    }
}
